<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="6" md="4" class="mt-5 pt-5 text-xs-center">
      <v-card>
        <v-card-text>
          <v-img
            :src="require('@/assets/logo.png')"
            class="my-3"
            contain
            height="100"
          ></v-img>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
  })
}
</script>

<style>

</style>
